export default "__VITE_ASSET__c5kPd6A___"